import './noPage.css';

export default function NoPage() {

    return (
      <div className="no-page">
        <h3>Nothing to do here.</h3>
      </div>
    )

}
